import { Box, Button } from '@mui/material';
import React from 'react';

interface SidebarFooterProps {
  onReset: () => void;
  onApply: () => void;
}

const SidebarFooter: React.FC<SidebarFooterProps> = ({ onReset, onApply }) => {
  return (
    <Box className="sidebar-footer">
      <Button className="m-blue-btn reset-btn" onClick={onReset}>
        Reset
      </Button>
      <Button className="m-blue-btn" onClick={onApply}>
        Apply
      </Button>
    </Box>
  );
};

export default SidebarFooter;
